<template>
  <v-card
    @click="showNotification"
    class="pa-4"
    :class="{ unread: !notification.read }"
    style="border-bottom: 2px solid lightgrey"
    flat
  >
    <v-container fluid class="pa-0">
      <v-row :dense="$vuetify.breakpoint.xsOnly">
        <v-col cols="12">
          <v-row dense align="center" class="mb-1">
            <v-col cols="6">
              <div :style="notificationTypeStyle">
                {{ notification.notification_type.label }}
              </div>
            </v-col>
            <v-col class="text-center" cols="6">
              <span class="text-body-1">{{ notification.title }} </span>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="$store.state.app_display_scheme" cols="12">
          <v-row
            :dense="$vuetify.breakpoint.xsOnly"
            align="center"
            class="text-body-1 flex-nowrap"
          >
            <v-col
              v-if="notification.request.is_urgency"
              cols="auto"
              class="flex-grow-0 flex-shrink-0"
            >
              <v-icon color="error" size="24">error</v-icon>
            </v-col>
            <v-col cols="auto" class="flex-grow-0 flex-shrink-0">
              <SchemeIcon
                :scheme="notification.request.scheme"
                height="24"
                width="24"
              />
            </v-col>
            <v-col class="overflow-hidden" style="min-width: 0">
              <span
                v-if="
                  notification &&
                  notification.request &&
                  notification.request.service
                "
                class="font-weight-bold text-capitalize service-name"
                >{{ notification.request.service.name }}
              </span>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="notification && notification.request" cols="12"
          >Dirección: {{ notification.request.full_address }}</v-col
        >

        <v-col
          v-if="
            notification.request &&
            notification.request.availability &&
            notification.request.availability.length > 0
          "
          cols="12"
          >Fecha y hora:
          {{
            notification.request.availability[0].date_from | formatDateTimeShort
          }}</v-col
        >
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import SchemeIcon from "./SchemeIcon.vue";
import { getContrastingTextColor } from "@/helpers/helpers";

export default {
  name: "NotificationItem",
  components: {
    SchemeIcon,
  },
  props: {
    notification: Object,
  },

  computed: {
    notificationTypeStyle: function () {
      const backgroundColor =
        this.notification.notification_type.backgroundColor;
      const color = getContrastingTextColor(backgroundColor);

      return `
        background-color:${backgroundColor};
        color:${color};
        padding: 6px;
        font-size: 12px;
        display: flex;
        justify-content: center;
        font-weight: 500;
        letter-spacing: 0.5px;
      `;
    },
  },

  methods: {
    showNotification(item) {
      this.$emit("show-notification", item);
    },
  },
};
</script>

<style scoped>
.unread {
  background: #e3f2fd !important;
}

.service-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  word-break: break-word;
}
</style>
